import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			'&:focus': {
				background: theme.palette.primary.dark,
			},
		}),
	},
};
